__turbopack_context__.v({
  "card": "program-job-card-module-scss-module__M46isq__card",
  "cardTag": "program-job-card-module-scss-module__M46isq__cardTag",
  "cardTitle": "program-job-card-module-scss-module__M46isq__cardTitle",
  "duration": "program-job-card-module-scss-module__M46isq__duration",
  "programIcon": "program-job-card-module-scss-module__M46isq__programIcon",
  "rightArrow": "program-job-card-module-scss-module__M46isq__rightArrow",
  "sponsoredBy": "program-job-card-module-scss-module__M46isq__sponsoredBy",
});
